import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

let cache = null;
const subs = new Set();
export const reloadCrmStatuses = () => api.get("/crm-statuses").then((r) => { cache = r.data; subs.forEach((f) => f(cache)); return cache; });

export function useCrmStatuses() {
  const [data, setData] = useState(cache);
  useEffect(() => { subs.add(setData); if (!cache) reloadCrmStatuses().catch(() => {}); return () => subs.delete(setData); }, []);
  return data;
}

export function CrmStatusBadge({ id, testid }) {
  const data = useCrmStatuses();
  const s = data?.items.find((x) => x.id === id);
  if (!s) return <span className="text-[11px] px-1.5 py-0.5 rounded border border-dashed border-red-300 text-red-700 bg-red-50" data-testid={testid}>Sans statut</span>;
  return <span className="text-[11px] px-1.5 py-0.5 rounded border font-medium whitespace-nowrap" style={{ color: s.color, borderColor: `${s.color}55`, background: `${s.color}12` }} data-testid={testid}>{s.label}</span>;
}

export function CrmStatusSelect({ dossier, onChanged }) {
  const data = useCrmStatuses();
  const [v, setV] = useState(dossier.crm_status ?? "");
  useEffect(() => setV(dossier.crm_status ?? ""), [dossier.crm_status]);
  if (!data) return null;
  const change = async (e) => {
    const val = e.target.value || null;
    setV(e.target.value);
    try { await api.post(`/crm-statuses/dossier/${dossier.id}`, { crm_status: val }); toast.success("Statut du dossier mis à jour"); reloadCrmStatuses(); onChanged?.(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Changement impossible"); }
  };
  const cur = data.items.find((x) => x.id === v);
  return (
    <select value={v} onChange={change} className="text-xs font-medium rounded border px-2 py-1 bg-white" style={cur ? { color: cur.color, borderColor: cur.color } : { color: "#B91C1C", borderColor: "#FCA5A5" }} data-testid="crm-status-select">
      <option value="">Sans statut</option>
      {data.items.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
    </select>
  );
}
